import React from 'react';
import { Alert, Typography } from '@mui/material';

interface CriticalOrderHowItWorksProps {
  monthlyCredit: string | number;
  surchargeMethod?: string | null;
  fixedAmount?: string | number;
  factor?: string | number;
}

const CriticalOrderHowItWorks: React.FC<CriticalOrderHowItWorksProps> = ({
  monthlyCredit,
  surchargeMethod,
  fixedAmount,
  factor
}) => {
  return (
    <Alert severity="info" sx={{ height: 'fit-content' }}>
      <Typography variant="body2">
        <strong>How it will work:</strong>
        <br />
        • Merchants get {monthlyCredit || '0'} critical order credits per month
        <br />
        • When they exceed this limit, the surcharge applies to each additional critical order
        <br />
        {surchargeMethod === 'FIXED_SURCHARGE' &&
          `• Fixed surcharge: $${fixedAmount || '0'} will be added to the delivery fee`}
        {surchargeMethod === 'FIXED_FACTOR' &&
          `• Factor surcharge: Delivery fee will be multiplied by ${factor || '1.0'}`}
        {!surchargeMethod && '• No surcharge configured - merchants can place unlimited critical orders'}
      </Typography>
    </Alert>
  );
};

export default CriticalOrderHowItWorks;
